import { useContext } from 'react';
import { InitialStateContext } from '../context/InitialState';

export const useSiteId = () => {
  const { siteId } = useContext(InitialStateContext);
  return siteId;
};
